import { CreditCard, Mail, UserRound } from "lucide-react";
import ParagraphTag from "../../../reusebale/Paragraph";

const ContactInfo = ({ paymentData }) => {
  return (
    <div className="bg-white rounded-xl">
      <div className="px-4 pt-7">
        <ParagraphTag
          content="Merchant Information"
          classes="text-darkColor font-popinsSemiBold text-lg mt-[-3px]"
        />
      </div>
      <div className="mt-1 ml-4">
        <div className="flex flex-row w-full py-7 gap-x-20">
          <div className="flex items-center">
            <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
              <CreditCard color="#FF814E" strokeWidth={2} size={20} />
            </div>
            <div className="pl-2">
              <ParagraphTag
                content="Account Name"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={paymentData?.name || "N/A"}
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs"
              />
            </div>
          </div>
          <div className="flex items-center">
            <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
              <UserRound color="#FF814E" strokeWidth={2} size={20} />
            </div>
            <div className="pl-2">
              <ParagraphTag
                content="Full Name"
                classes="text-darkColor font-popinsSemiBold text-sm"
              />
              <ParagraphTag
                content={
                  `${paymentData?.firstName || ""} ${
                    paymentData?.lastName || ""
                  }`.trim() || "N/A"
                }
                classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs"
              />
            </div>
          </div>
          <div className="flex ">
            <div className=" flex items-center">
              <div className="w-9 h-9 rounded-full flex justify-center items-center bg-bgColor">
                <Mail color="#FF814E" strokeWidth={2} size={20} />
              </div>
              <div className="pl-2">
                <ParagraphTag
                  content="Email Address"
                  classes="text-darkColor font-popinsSemiBold text-sm"
                />
                <ParagraphTag
                  content={paymentData?.email || "N/A"}
                  classes="text-darkColor/40 font-popinsRegular mt-[-2px] text-xs"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
